import { Pipe, PipeTransform } from '@angular/core';
import { ThemesService } from '../core/themes.service';

@Pipe({
    name: 'isOrg',
    standalone: false
})
export class IsOrgPipe implements PipeTransform {
    organization: string = ''
    constructor(private themesService: ThemesService) {
        this.themesService.get$().subscribe((org_name) => {
            this.organization = org_name
        })
    }

    transform(value: string, mode?: 'reverse'): boolean {
        const result = this.organization === value
        return mode === 'reverse' ? !result : result;
    }
}
